import { UsedProductDetails } from "@/@types";
import { UsedProductDetailsResponse } from "../usedProduct/models/UsedProductDetailsResponse";

export function mapUsedProductDetails(response: UsedProductDetailsResponse): UsedProductDetails {
    return {
        image: response.image,
        name: response.name,
        model: response.model,
        serialNo: response.serial_no,
        year: response.year,
        supplier: response.supplier,
        city: response.city,
        catLink: response.cat_link,
        price: response.price,
        currency: response.currency,
        customPrice: response.custom_price,
        customCurrency: response.custom_currency,
        offer: response.offer,
        slug: response.slug,
        photos: response.photos?.map(photo => ({
            media: photo.media,
            localName: photo.local_name,
        })) || [],
        videos: response.videos?.map(video => ({
            media: video.media,
            localName: video.local_name,
        })) || [],
        family: {
            name: response.family?.name || '',
            slug: response.family?.slug || '',
        },
        features: response.features?.map(feature => ({
            name: feature.name,
        })) || [],
        sections: response.sections?.map(section => ({
            category: {
                name: section.category?.name || '',
            },
            booleanFeatures: section.booleanFeatures?.map(booleanFeature => ({
                concept: booleanFeature.concept,
                value: booleanFeature.value,
                note: booleanFeature.note,
            })) || [],
            discreteFeatures: section.discreteFeatures?.map(discreteFeature => ({
                concept: discreteFeature.concept,
                value: discreteFeature.value,
                note: discreteFeature.note,
            })) || [],
            noteFeatures: section.noteFeatures?.map(noteFeature => ({
                concept: noteFeature.concept,
                value: noteFeature.value,
                note: noteFeature.note,
            })) || [],
            sectionNotes: section.sectionNotes?.map(sectionNote => ({
                concept: sectionNote.concept,
                note: sectionNote.note,
            })) || [],
        })) || [],
        tires: response.tires?.map(tire => ({
            tireFeatures: tire.tireFeatures?.map(tireFeature => ({
                concept: tireFeature.concept,
                manufacturer: tireFeature.manufacturer,
                treadDepth: tireFeature.tread_depth,
                remainingLifePercentage: tireFeature.remaining_life_percentage,
                summary: tireFeature.summary,
                treadCutChunks: tireFeature.tread_cut_chunks,
                sideCuts: tireFeature.side_cuts,
            })) || [],
        })) || [],
        undercarriages: response.undercarriages?.map(undercarriage => ({
            undercarriageFeatures: undercarriage.undercarriageFeatures?.map(undercarriageFeature => ({
                concept: undercarriageFeature.concept,
                leftMeasurement: undercarriageFeature.left_measurement,
                leftWearPercentage: undercarriageFeature.left_wear_percentage,
                leftPossibleHours: undercarriageFeature.left_possible_hours,
                rightMeasurement: undercarriageFeature.right_measurement,
                rightWearPercentage: undercarriageFeature.right_wear_percentage,
                rightPossibleHours: undercarriageFeature.right_possible_hours,
            })) || [],
        })) || [],
    };
}